var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticStyle:{"height":"100%"},attrs:{"gutter":2}},[_c('a-col',{staticStyle:{"height":"100%"},attrs:{"span":24}},[_c('a-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.jumpSpecifylink()}}},[_c('i',{staticClass:"anticon anticon-save"}),_vm._v(" "+_vm._s(_vm.l("跳转"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }